module.exports = __webpack_public_path__ + "img/1.e43dc38a.jpg";